export function decodeValue(value: string, separator: string): string {
    return value.replace(/%7E/g, separator)
}

export function encodeValue(value: string, separator: string): string {
    // Escape the separator character as it could be a regex control character
    const regex = new RegExp(`\\${separator}`, "g")
    return value.replace(regex, "%7E")
}
